export const experience = [
  {
    role: "Software Engineer Co-op",
    place: "Chewy",
    period: "Jun 2026 – Dec 2026",
    desc: "I am currently on the UX Engineering (UXE) and Accessibility teams, working on internal tools for both that involve MCP servers/plugins, manual auditing, and Chewy's component library.",
  },
  {
    role: "Husky Ambassador",
    place: "Northeastern University",
    period: "Aug 2024 – Present",
    desc: "Conducting 50+ campus tours in Boston & Oakland. Represented Oakland campus at counselor fly-in panel, and managed admissions Instagram content generating over 1000 views per post.",
  },
  {
    role: "Code Sensei",
    place: "Code Ninjas, Brooklyn, NY",
    period: "May 2025 – Aug 2025",
    desc: "Mentored 40+ neurotypical and neurodivergent students weekly in block-based coding. Led camps for 30 students per session on video editing, Scratch coding, and 3D printing.",
  },
];

export const education = [
  {
    school: "Northeastern University",
    degree: "B.S. Computer Science — Khoury College",
    period: "Sept 2024 – May 2028",
    detail: "GPA: 3.98/4.0 · Dean's List · John Martinson Honors Program",
  },
];

export const skills = [
  { label: "Languages", items: ["Java", "Python", "Kotlin", "C", "JavaScript"] },
  { label: "Frameworks & Libraries", items: ["React", "CSS", "Supabase", "JUnit", "NumPy", "Matplotlib"] },
  { label: "APIs & Platforms", items: ["Claude API", "Gemini API", "OpenAI API", "Spotify API", "Groq API"] },
  { label: "Developer Tools", items: ["Git/GitHub", "IntelliJ IDEA", "VS Code", "Jenkins Pipelines", "JFrog", "Chromatic", "Atlassian"] },
];

export const courses = [
  "Algorithms and Data", "Computer Systems", "Discrete Structures",
  "Foundations of Data Science", "Fundamentals of CS 1 & 2",
  "Program Design & Implementation 2",
];